// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-body.help .red-box svg {
  color: #fff;
  font-size: 28px;
}`, "",{"version":3,"sources":["webpack://./src/components/Help.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,eAAe;AACjB","sourcesContent":[".app-body.help .red-box svg {\r\n  color: #fff;\r\n  font-size: 28px;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
